import * as React from "react";
import { Link as LinkReactRouterDom } from "react-router-dom";
import { CMSState, Id, ImageSize, Link } from "../../../../cms/blocks/types.gen";
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { parseImageUrl } from "../../../../drupal/rendering/image_utils.mod";
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types";
import { extra_images } from "../../../utils/extra_images.mod";
import { getClassName, link } from "../../../../cms/blocks/utils.gen";

export type FeaturedContentBlockProps = {
  alignImage: 'right' | 'left';
  backgroundImage: string;
  title?: string;
  label?: string;
  intro?: string;
  field_image?: ParsedMediaImage;
  image?: Id;
  image_alt?: string;
  image_size?: ImageSize<extra_images>;
  primaryButton?: Link;
  isStyleguide?: boolean

  button?: {
    text: string;
    url: string;
  }
  imageStyleguide?: {
    src: string;
    srcSet: string;
    alt: string;
  }
}

export const FeaturedContentBlock = (props: FeaturedContentBlockProps) => {
  const {
    alignImage,
    backgroundImage,
    title,
    label,
    intro,
    button,
    field_image,
    image,
    image_alt,
    image_size,
    primaryButton,
    isStyleguide,
    imageStyleguide,

  } = props;

  return (
    <section className={`block block--featured-content featured-content featured-content--image-${alignImage} ${backgroundImage ? 'featured-content--has-background' : ''}`}>
      <div className="featured-content__container container container--m grid--block">
        {backgroundImage && (
          <span className={`featured-content__background featured-content__background--${backgroundImage}`} />
        )}
        <div className="featured-content__inner">
          <div className="featured-content__column featured-content__column--visual">

            {isStyleguide ?
              <div className="featured-content__visual">
                <img className="featured-content__image lazyload"
                  src="/frontend/images/empty.png"
                  data-src={imageStyleguide.src}
                  data-srcSet={imageStyleguide.srcSet}
                  alt={imageStyleguide.alt}
                  sizes="auto"
                  width="450"
                  height="450"
                />
              </div>
              : image &&
              <div className="featured-content__visual">
                <img className="featured-content__image lazyload"
                  src="/frontend/images/empty.png"
                  data-src={`${field_image?.field_media_image?.image?.style_urls['450x450']}`}
                  data-srcset={`${parseImageUrl(
                    field_image?.field_media_image?.image?.style_urls['450x450']
                  )} 450x450, ${parseImageUrl(
                    field_image?.field_media_image?.image?.style_urls['600x600']
                  )} 600x600, ${parseImageUrl(
                    field_image?.field_media_image?.image?.style_urls['1200x1200']
                  )}`}
                  alt={image_alt}
                  sizes="auto"
                  width="600"
                  height="600"
                />
              </div>
            }
          </div>
          <div className="featured-content__column featured-content__column--message">
            <div className="featured-content__message">
              {label && <span className="featured-content__label label">{label}</span>}
              {title && <h2 className="featured-content__title title--l">{title}</h2>}
              {intro && <div className="featured-content__intro text--styled text--l" dangerouslySetInnerHTML={{ __html: intro }} />}
              {isStyleguide ?
                button &&
                <LinkReactRouterDom className="featured-content__cta button button--primary" to={button.url}>{button.text}</LinkReactRouterDom>
                : props.primaryButton && link(props.primaryButton, { classname: "featured-content__cta button button--primary" }, props.primaryButton.title,
                  () => {
                    window.dataLayer.push({
                      event: 'event.refresco',
                      category: 'FeaturedContentBlock',
                      action: props.primaryButton.title,
                      label: window.location.pathname,
                    })
                  })
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}